import * as React from 'react';
import type { SVGProps } from 'react';
const SvgProtectPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#FF678C" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.646 10.518V9.037c0-2.046-1.632-3.704-3.646-3.704-2.013 0-3.646 1.658-3.646 3.704v1.481M12 13.852v1.481m-2.333 3.334h4.666c1.226 0 1.838 0 2.306-.243.412-.213.746-.553.956-.97.238-.476.238-1.098.238-2.343v-1.037c0-1.245 0-1.867-.238-2.342a2.2 2.2 0 0 0-.956-.971c-.468-.243-1.08-.243-2.306-.243H9.667c-1.225 0-1.838 0-2.306.243a2.2 2.2 0 0 0-.956.97c-.238.476-.238 1.098-.238 2.343v1.037c0 1.245 0 1.867.238 2.342.21.418.545.758.956.971.468.243 1.08.243 2.306.243"
    />
  </svg>
);
export default SvgProtectPdf;
